<template>
  <div>
    <module-list :modules="modules" @updateSetup="doUpdate" @enabledChange='doChange'/>
  </div>
</template>

<script>
import ModuleList from "@/components/ModuleList.vue";
import menuCustomization from "@/mixins/menuCustomization.js";

export default {
  components: {
    ModuleList
  },
  mixins: [menuCustomization],
  data() {
    return {
      modules: [
        {
          id: "nav-document-1",
          title: "进销存",
          enabled: true,
          items: [
          {
              id: "report-planyear",
              logo: "iconfont icon-ywythd red-font",
              title: "销售计划分析",
              path: "/sale/planyear_report",
              enabled: true,
            },
            {
              id: "report-sale",
              logo: 'iconfont icon-xsmx green-font',
              title: "销售订单分析",
              path: "/sale/order_report",
              enabled: true,
            },
            {
              id: "report-saleoutmonth",
              logo: 'iconfont icon-chfx green-font',
              title: "销售出货分析",
              path: "/sale/out_month",
              enabled: true,
            },
            {
              id: "report-saleinmonth",
              logo: 'iconfont icon-tksqd red-font',
              title: "销售退货分析",
              path: "/sale/in_month",
              enabled: true,
            },
            {
              id: "report-saleExecute",
              logo: 'iconfont icon-xszxtz red-font',
              title: "销售执行台账",
              path: "/sale/execute",
              enabled: true,
            },
            {
              id: "report-purchase",
              logo: 'iconfont icon-cgmx blue-font',
              title: "采购订单分析",
              path: "/purchase/order_report",
              enabled: true,
            },
            {
              id: "sale-report-saleprofit",
              logo: 'iconfont icon-yphj green-font',
              title: "毛利润分析",
              path: "/sale/profit_report",
              enabled: true,
            },
            {
              id: "report-purchasein",
              logo: 'iconfont icon-cgrkmx green-font',
              title: "采购入库明细",
              path: "/purchase/purchasein_report",
              enabled: true,
            },
            {
              id: "report-purchaseExecute",
              logo: 'iconfont icon-cgddzx orange-font',
              title: "采购执行台账",
              path: "/purchase/execute",
              enabled: true,
            },
            {
              id: "stock-report-datalist",
              logo: 'iconfont icon-kcmx red-font',
              title: "库存明细表",
              path: "/stock/report",
              enabled: true,
            },
            {
              id: "prodiodetail",
              logo: 'iconfont icon-xsch green-font',
              title: "库存收发明细",
              path: "/stock/prodiodetail_report",
              enabled: true,
            },
            {
              id: "purcsale",
              logo: 'iconfont icon-kcjxfx orange-font',
              title: "库存进销分析",
              path: "/stock/purcsale",
              enabled: true,
            },
            {
              id: "batchAge",
              logo: 'iconfont icon-kczl green-font',
              title: "库存账龄表",
              path: "/stock/batchage",
              enabled: true,
            },
            {
              id: "batchdetail",
              logo: 'iconfont icon-cksz blue-font',
              title: "批次库存明细",
              path: "/stock/batchdetail_report",
              enabled: true,
            }
          ]
        },
        {
          id: "nav-make-3",
          title: "制造",
          enabled: true,
          items: [
            {
              id: "make-report-makehour",
              logo: 'iconfont icon-scrb orange-font',
              title: "生产日报表",
              path: "/production/make_hour_report",
              enabled: true,
            },
            {
              id: "make-report-inprocess",
              logo: 'iconfont icon-gdzz blue-font',
              title: "工单在制分析",
              path: "/production/make_report",
              enabled: true,
            },
            {
              id: "make-report-productionprogress",
              logo: 'iconfont icon-scjd green-font',
              title: "生产进度",
              path: "/production/schedule_report",
              enabled: true,
            },
            {
              id: "make-report-productionloss",
              logo: 'iconfont icon-scsh red-font',
              title: "生产损耗",
              path: "/production/loss_report",
              enabled: true,
            },
            {
              id: "osmake-report-inprocess",
              logo: 'iconfont icon-wxzz green-font',
              title: "外协在制",
              path: "/out_prod/make_report",
              enabled: true,
            },
            {
              id: "osmake-report-productionprogress",
              logo: 'iconfont icon-wxjd blue-font',
              title: "外协进度",
              path: "/out_prod/schedule_report",
              enabled: true,
            },
            {
              id: "osmake-report-productionloss",
              logo: 'iconfont icon-wxsh green-font',
              title: "外协损耗",
              path: "/out_prod/loss_report",
              enabled: true,
            },
            // {
            //   id: "make-report-makedaily",
            //   logo: 'iconfont icon-zzgdzx orange-font',
            //   title: "制造工单执行",
            //   path: "/out_prod/makedaily_report",
            //   enabled: true,
            // },
            // {
            //   id: "osmake-report-osmakeExecute",
            //   logo: 'iconfont icon-wxgdzx blue-font',
            //   title: "外协工单执行",
            //   path: "/out_prod/osmake_execute_report",
            //   enabled: true,
            // },
            {
              id: "make-report-makein",
              logo: 'iconfont icon-gdwgfx red-font',
              title: "工单完工分析",
              path: "/out_prod/makein_report",
              enabled: true,
            },
            {
              id: "qc-report-iqc",
              logo: 'iconfont icon-iqcjlfx orange-font',
              title: "IQC进料分析",
              path: "/out_prod/iqc_report",
              enabled: true,
            },
            {
              id: "qc-report-fqc",
              logo: 'iconfont icon-fqcjyfx orange-font',
              title: "F/OQC检验分析",
              path: "/out_prod/fqc_report",
              enabled: true,
            },
            {
              id: "qc-report-qc",
              logo: 'iconfont icon-qcjyfx green-font',
              title: "QC检验分析",
              path: "/out_prod/qc_report",
              enabled: true,
            }
          ]
        },
        {
          id: "nav-make-4",
          title: "拆解",
          enabled: true,
          items: [
            {
              id: "disassemble-report-makehour",
              logo: 'iconfont icon-scrb orange-font',
              title: "拆解日报表",
              path: "/disassemble/hour_report",
              enabled: true,
            },
            {
              id: "disassemble-report-inprocess",
              logo: 'iconfont icon-gdzz blue-font',
              title: "拆解在制分析",
              path: "/disassemble/inprocess_report",
              enabled: true,
            },
            {
              id: "disassemble-report-productionprogress",
              logo: 'iconfont icon-scjd green-font',
              title: "拆解进度",
              path: "/disassemble/progress_report",
              enabled: true,
            },
            {
              id: "disassemble-report-productionloss",
              logo: 'iconfont icon-scsh red-font',
              title: "拆解损耗",
              path: "/disassemble/loss_report",
              enabled: true,
            },
            {
              id: "disassemble-report-makein",
              logo: 'iconfont icon-gdwgfx red-font',
              title: "拆解完工",
              path: "/disassemble/in_report",
              enabled: true,
            }
          ]
        },
        {
          id: "nav-report-2",
          title: "财务",
          enabled: true,
          items: [
            {
              id: "monry-report-recdetail",
              logo: 'iconfont icon-ysmx green-font',
              title: "应收账款分析",
              path: "/money/receipt_report",
              enabled: true,
            },
            {
              id: "monry-report-paydetail",
              logo: 'iconfont icon-yfmx orange-font',
              title: "应付账款分析",
              path: "/money/payment_report",
              enabled: true,
            },
            {
              id: "monry-report-totalrecdetail",
              logo: 'iconfont icon-yszk blue-font',
              title: "应收账款余额",
              path: "/money/totalrecdetail_report",
              enabled: true,
            },
            {
              id: "monry-report-totalrecdetailbyseller",
              logo: 'iconfont icon-yszk blue-font',
              title: "业务员余额",
              path: "/money/totalrecdetailbyseller_report",
              enabled: true,
            },
            {
              id: "monry-report-totalpaydetail",
              logo: 'iconfont icon-yfzk green-font',
              title: "应付账款余额",
              path: "/money/totalpaydetail_report",
              enabled: true,
            },
            {
              id: "money-report-sendoutgoodsdetail",
              logo: 'iconfont icon-fcsp orange-font',
              title: "发出商品分析",
              path: "/money/sendoutgoodsdetail_report",
              enabled: true,
            },
            {
              id: "monry-report-agingaccountsrec",
              logo: 'iconfont icon-yszlfx red-font',
              title: "应收账龄分析",
              path: "/money/agingaccountsrec_report",
              enabled: true,
            },
            {
              id: "monry-report-paytenestidetail",
              logo: 'iconfont icon-yfzgfx orange-font',
              title: "应付暂估分析",
              path: "/money/paytenestidetail_report",
              enabled: true,
            },
            {
              id: "monry-report-agingaccountspay",
              logo: 'iconfont icon-yfzlfx red-font',
              title: "应付账龄分析",
              path: "/money/agingaccountspay_report",
              enabled: true,
            },
            {
              id: "finance-report-balance",
              logo: 'iconfont icon-zcfz orange-font',
              title: "资产负债表",
              path: "/finance/report_balance",
              enabled: true,
            },
            {
              id: "finance-report-income",
              logo: 'iconfont icon-lrb orange-font',
              title: "利润表",
              path: "/finance/report_income",
              enabled: true,
            },
            {
              id: "finance-report-cashflow",
              logo: 'iconfont icon-xjllb orange-font',
              title: "现金流量表",
              path: "/finance/report_cashflow",
              enabled: true,
            },
            {
              id: "finance-report-feestatistics",
              logo: 'iconfont icon-fyhz orange-font',
              title: "费用汇总表",
              path: "/finance/report_feestatistics",
              enabled: true,
            },
            {
              id: "money-report-billar",
              logo: "iconfont icon-yszk blue-font",
              title: "应收票据余额",
              path: "/money/billar_report",
              enabled: true,
            },
            {
              id: "money-report-billap",
              logo: "iconfont icon-yfzk green-font",
              title: "应付票据余额",
              path: "/money/billap_report",
              enabled: true,
            },
            {
              id: "report-feebudget",
              logo: "iconfont icon-zjjh blue-font",
              title: "费用预算分析",
              path: "/finance/report_feebudget",
              enabled: true,
            },
          ]
        }
      ]
    };
  },
};
</script>

<style scoped>
</style>